import React from 'react';

import moment from 'moment';
import { array, bool, func, object, oneOfType, string } from 'prop-types';

import { key, trigger } from '@philips-emr/tws-utils';

import { EventTokenList } from '../..';

function transformEvent(event) {
  const copy = moment.utc(event.date);
  const title = `${copy.format('HH:mm')} | ${event.title}`;

  return { ...event, date: copy, title };
}

function DayTitle({ active, children }) {
  const classname = `c-calendar-day__title ${active ? '' : 'is-inactive'}`;

  return <div className={classname}>{children}</div>;
}

DayTitle.propTypes = {
  active: bool,
  children: string,
};

function AddCalendarEvent({ onClick }) {
  return <div className="c-calendar-day__add-event" onClick={onClick} />;
}

AddCalendarEvent.propTypes = {
  onClick: func,
};

function DayEvents({ events, onEventClick }) {
  if (!events || (events && !events.length)) {
    return null;
  }

  const eventTokens = events.filter((event) => event.date).map(transformEvent);

  if (!eventTokens.length) {
    return null;
  }

  return (
    <div className="c-calendar-day__events">
      <EventTokenList data={eventTokens} displayQuantity={2} onClick={onEventClick}/>
    </div>
  );
}

DayEvents.propTypes = {
  events: array,
  onClick: func,
  onEventClick: func,
};

function Day({ active, canAddNew, date, events, onAddNew, onEventClick }) {
  const title = date.date().toString();

  return (
    <div className="c-calendar-day">
      <div className="c-calendar-day__header">
        <DayTitle active={active}>{title}</DayTitle>

        {canAddNew &&
        <AddCalendarEvent onClick={trigger(onAddNew, { date })} />}
      </div>
      <div className="c-calendar-day__content">
        <DayEvents events={events} onEventClick={onEventClick} />
      </div>
    </div>
  );
}

Day.propTypes = {
  active: bool,
  date: oneOfType([string, object]),
  events: array,
  canAddNew: bool,
  onAddNew: func,
  onEventClick: func,
};

function MonthlyWeekRow({ canAddNew, onAddNew, onEventClick, rangeEnabled, week }) {
  return (
    <div className="c-calendar__row">
      {week.map(({ inRange, ...day }) => (
        <Day
        {...day}
        key={key('c-calendar-day')}
        canAddNew={canAddNew && rangeEnabled === inRange}
        onEventClick={onEventClick}
        onAddNew={onAddNew}
        />
      ))}
    </div>
  );
}

MonthlyWeekRow.propTypes = {
  canAddNew: bool,
  onAddNew: func,
  onEventClick: func,
  rangeEnabled: bool,
  week: array,
};

export default MonthlyWeekRow;
